// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SidePanelNavigation-base__em6UJ{display:flex;flex-direction:column;flex-shrink:0;width:var(--size-full)}.SidePanelNavigation-row__dTnZC{display:flex;align-items:center;height:var(--size-13);padding:var(--size-2) var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "SidePanelNavigation-base__em6UJ",
	"row": "SidePanelNavigation-row__dTnZC"
};
export default ___CSS_LOADER_EXPORT___;
